import { twMerge } from 'tailwind-merge';
import Loader from './svg/Loader';

interface Props {
  isLoading?: boolean;
  onClick: Function;
  disabled?: boolean;
  hide?: boolean;
  className?: string;
  text?: string;
}

export default function LoadMoreButton({isLoading,onClick,disabled,hide, className, text = 'المزيد'}: Props) {
  if (hide) return null;
  if (isLoading) {
    return (
      <div className='w-full flex items-center justify-center'>
        <Loader/>
      </div>
    )
  }

  return (
    <div className={twMerge('rounded-[6px] h-[36px] grid place-items-center w-full tablet:w-fit bg-gray-100 dark:bg-quaternary px-[12px] cursor-pointer tablet:mx-auto transition-all duration-300 hover:scale-[103%]', className)} onClick={() => onClick()}>
      <span className='text-dark dark:text-white h6'>{text}</span>
    </div>
  )
}